// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

const scripts = [
    {
        src:
            'https://cdnjs.cloudflare.com/ajax/libs/postscribe/2.0.8/postscribe.min.js',
        type: 'script',
    },
];

export default class Kaltura extends Component<Props> {
    loadScripts = scripts => {
        const { partner_id, uiconfig_id, entry_id } = this.props.content;
        if (partner_id === '' || uiconfig_id === '' || entry_id === '') return;

        const width = this.props.content.width || 560;
        const height = this.props.content.height || 315;

        loadScripts(scripts)
            .then(() => {
                postscribe(
                    this.kaltura,
                    `<script src='https://cdnapisec.kaltura.com/p/${partner_id}/sp/${partner_id}00/embedIframeJs/uiconf_id/${uiconfig_id}/partner_id/${partner_id}?autoembed=true&entry_id=${entry_id}&playerId=kaltura_player_${partner_id}${entry_id}&cache_st=${partner_id}${entry_id}&width=${width}&height${height}&flashvars[streamerType]=auto'></script>`
                );
            })
            .catch(error => {
                console.log('Could not load kaltura scripts: ', error);
            });
    };

    componentDidMount() {
        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts) this.loadScripts(customScripts);
        else this.loadScripts(scripts);
    }

    componentWillUnmount() {
        scripts.forEach(s => {
            const e = document.getElementById(s.id);
            if (e) {
                e.outerHTML = '';
            }
        });
    }

    render() {
        const { partner_id, entry_id } = this.props.content;
        const width = this.props.content.width || 560;
        const height = this.props.content.height || 315;

        const divAttr = {
            itemProp: 'video',
            itemType: 'http://schema.org/VideoObject',
        };
        const name = { itemProp: 'name' };
        const description = { itemProp: 'description' };
        const duration = { itemProp: 'duration' };
        const thumbnail = { itemProp: 'thumbnail' };
        const widthAttr = { itemProp: 'width' };
        const heightAttr = { itemProp: 'height' };

        return (
            <div
                ref={div => (this.kaltura = div)}
                id={`inplayer_kaltura-${partner_id}${entry_id}`}
                style={{ width: width + 'px', height: height + 'px' }}
                itemScope
                {...divAttr}
            >
                <span {...name} content="Archer Lana-HD" />
                <span {...description} content="" />
                <span {...duration} content="12" />
                <span
                    {...thumbnail}
                    content={`http://cfvod.kaltura.com/p/${partner_id}/sp/${partner_id}00/thumbnail/entry_id/${entry_id}/version/100001`}
                />
                <span {...widthAttr} content={width} />
                <span {...heightAttr} content={height} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Kaltura.js